'use client'

import { useFavorites } from '@/context/FavoritesContext'
import type { ContentItem } from '@/lib/types'
import { cn } from '@/lib/utils'

interface FavoriteButtonProps {
  item: ContentItem
  variant?: 'icon' | 'full'
  className?: string
}

export function FavoriteButton({ item, variant = 'icon', className }: FavoriteButtonProps) {
  const { isFavorite, toggleFavorite } = useFavorites()
  const active = isFavorite(item.id)

  if (variant === 'full') {
    return (
      <button
        type="button"
        onClick={() => toggleFavorite(item)}
        className={cn('btn-ghost', active && 'border-crimson-500/60 bg-crimson-600/20', className)}
        aria-pressed={active}
      >
        <Heart filled={active} />
        {active ? 'Favorilerde' : 'Favorilere Ekle'}
      </button>
    )
  }

  return (
    <button
      type="button"
      onClick={(e) => {
        e.preventDefault()
        e.stopPropagation()
        toggleFavorite(item)
      }}
      aria-label={active ? 'Favorilerden çıkar' : 'Favorilere ekle'}
      aria-pressed={active}
      className={cn(
        'grid h-9 w-9 place-items-center rounded-full border backdrop-blur transition-all',
        active
          ? 'border-crimson-500/60 bg-crimson-600/80 text-white'
          : 'border-white/20 bg-black/50 text-white/80 hover:bg-black/70 hover:text-white',
        className
      )}
    >
      <Heart filled={active} />
    </button>
  )
}

function Heart({ filled }: { filled: boolean }) {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill={filled ? 'currentColor' : 'none'}
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
    >
      <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
    </svg>
  )
}
